import React from 'react'
import { Typography, Box, makeStyles, Container } from '@material-ui/core'
import ChevronLeft from '@material-ui/icons/ChevronLeft'
import { get } from 'lodash'
import PTReferential from '../../atoms/Referential'
import { ROOT_VIEW } from './constants'
import useReferer from '../../../hooks/useReferer'

const useStyles = makeStyles((theme) => ({
  subtitle: {
    marginBottom: theme.spacing(4),
  },
  topContainer: {
    display: 'flex',
  },
  titleContainer: {
    flex: 1,
  },
  previousIcon: {
    cursor: 'pointer',
  },
}))

const buttonClick = (setView, referer) => {
  setView(ROOT_VIEW)
  if (window.parent) {
    window.parent.postMessage(
      { event_type: 'picto-widget-modal-change-view', view: ROOT_VIEW },
      referer,
    )
  }
}

const BackButton = ({ setView }) => {
  const classes = useStyles()
  const referer = useReferer()

  return (
    <ChevronLeft
      className={classes.previousIcon}
      fontSize="large"
      onClick={() => buttonClick(setView, referer)}
    />
  )
}

const Referential = ({ card, setView }) => {
  const classes = useStyles()
  const referential = get(card, 'accessibility_description.referential', [])
  const title = get(card, 'content.title', '')
  return (
    <Container maxWidth="md">
      <Box className={classes.topContainer}>
        <BackButton setView={setView} />
        <Box className={classes.titleContainer}>
          <Typography align="center" variant="h4">
            {`"${title}"`}
          </Typography>
          <Typography className={classes.subtitle} align="center" variant="h5">
            Consultez l'accessibilité de ce lieu
          </Typography>
        </Box>
      </Box>
      <PTReferential referential={referential} version="2" />
    </Container>
  )
}

export default Referential
